import React, { useState, useRef, useEffect } from 'react';
import { 
  Dialog, DialogTitle, DialogContent, 
  DialogActions, TextField, Button, Stack 
} from '@mui/material';
import CowTagbyId from '../CowTagbyId/Cowtagbyid';

const ProgramDetailDialog = ({ open, handleClose, onSubmit }) => {
  // 1. Initialize state as an object
  const [formValues, setFormValues] = useState({
    title: '',
    description: '',
    participatingcows: ''
  });

  const [errors, setErrors] = useState({});
//  const [cowlistlength, setcowlistlength] = useState(0);

  const field1Ref = useRef(null);


  // 2. Dynamic Change Handler (handles all fields)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    
    // Clear error for this field when user types
    if (errors[name]) {
      setErrors({ ...errors, [name]: false });
    }
};

const handlecowtag=(data)=>{

const idText = data.CowId;
console.log(idText);
var existingtext = formValues.participatingcows.toString();
console.log(existingtext);
console.log(existingtext.length);
const cowlistlength = existingtext.length;

if(cowlistlength > 0){
      setFormValues({ ...formValues, participatingcows: formValues.participatingcows + "," + idText });
} else {
        setFormValues({ ...formValues, participatingcows: idText });
//  formValues.participatingcows.value = data.Tag;
}
field1Ref.current.focus();

}

//useEffect(()=>{
//  console.log(formValues);
//  console.log("final value " + formValues.participatingcows + " " + formValues.participatingcows.length);
////  setcowlistlength(formValues.participatingcows.length);
//}, [formValues]);

const handleConfirm = () => {
    // Simple Validation: Check if required fields are empty
    const newErrors = {};
    if (!formValues.title) newErrors.title = true;
    if (!formValues.description) newErrors.description = true;
    if (!formValues.participatingcows) newErrors.participatingcows = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      onSubmit(formValues); // Pass the whole object back
      resetAndClose();
    }
  };

const resetAndClose = () => {
    setFormValues({ title: '', description: '', participatingcows: '' });
    setErrors({});
    handleClose();
  };

  return(
    <Dialog open={open} onClose={resetAndClose} 

    PaperProps={{
      sx: {
      width: '350px',     // Fixed width      
     maxWidth: '100%',   // Prevents it from overflowing on mobile
    }
    }}
    // style={{
    //   width:'50%'
    // }}
    //  fullWidth = {true}
    //  maxWidth="xs"
    >
    <DialogTitle>Program Details</DialogTitle>
    <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
            <TextField
            name="title"
            label="Program Title"
            fullWidth
            required
            inputRef={field1Ref}            
            error={errors.title}
            value={formValues.title}
            onChange={handleChange}
          />
          <TextField
            name="description"
            label="Program Description"
            fullWidth
            value={formValues.description}
            onChange={handleChange}
          />
          <TextField
            name="participatingcows"
            label="Participating Cows"
            // style={{width:
            //   {
            //     xs: '100%', // Mobile: 100% width
            //     sm: '50%',  // Tablet: 50% width
            //     md: '300px' // Desktop: Fixed 300px
            //   }
            // }}
//            fullWidth
            required
            error={errors.participatingcows}
            value={formValues.participatingcows}
            onChange={handleChange}
          />
          <CowTagbyId onSelect={handlecowtag}/>
        </Stack>
    </DialogContent>
    <DialogActions>
        <Button onClick={resetAndClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained">
          Save Details
        </Button>
      </DialogActions>
    </Dialog>
);


}

export default ProgramDetailDialog;